// TYPE ELITE — Color utilities
export function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

export function hsvToRgb(h, s, v) {
  s /= 100; v /= 100;
  const c = v * s, x = c * (1 - Math.abs(((h / 60) % 2) - 1)), m = v - c;
  let r = 0, g = 0, b = 0;
  if (h < 60) { r = c; g = x; }
  else if (h < 120) { r = x; g = c; }
  else if (h < 180) { g = c; b = x; }
  else if (h < 240) { g = x; b = c; }
  else if (h < 300) { r = x; b = c; }
  else { r = c; b = x; }
  return [Math.round((r + m) * 255), Math.round((g + m) * 255), Math.round((b + m) * 255)];
}
export function rgbToHex(r, g, b) {
  const to = (n) => clamp(Math.round(n), 0, 255).toString(16).padStart(2, '0');
  return `#${to(r)}${to(g)}${to(b)}`.toUpperCase();
}
export function hexToRgb(hex) {
  const m = /^#?([a-f0-9]{6})$/i.exec((hex || '').trim());
  if (!m) return null;
  const n = parseInt(m[1], 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}
export function rgbToHsv(r, g, b) {
  r /= 255; g /= 255; b /= 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min;
  let h = 0; const s = max === 0 ? 0 : d / max; const v = max;
  if (d !== 0) {
    if (max === r) h = ((g - b) / d) % 6;
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h *= 60; if (h < 0) h += 360;
  }
  return [Math.round(h), Math.round(s * 100), Math.round(v * 100)];
}
export function rgbToHsl(r, g, b) {
  r /= 255; g /= 255; b /= 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0, l = (max + min) / 2;
  const d = max - min;
  if (d !== 0) {
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h *= 60;
  }
  return [Math.round(h), Math.round(s * 100), Math.round(l * 100)];
}
export function hslToRgb(h, s, l) {
  h /= 360; s /= 100; l /= 100;
  if (s === 0) { const v = Math.round(l * 255); return [v, v, v]; }
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const hk = (t) => { t = (t + 1) % 1; if (t < 1/6) return p + (q - p) * 6 * t; if (t < 1/2) return q; if (t < 2/3) return p + (q - p) * (2/3 - t) * 6; return p; };
  return [Math.round(hk(h + 1/3) * 255), Math.round(hk(h) * 255), Math.round(hk(h - 1/3) * 255)];
}
export function harmony(h, kind) {
  switch (kind) {
    case 'Complementary': return [h, (h + 180) % 360];
    case 'Analogous': return [(h + 330) % 360, h, (h + 30) % 360];
    case 'Triadic': return [h, (h + 120) % 360, (h + 240) % 360];
    case 'Split Complementary': return [h, (h + 150) % 360, (h + 210) % 360];
    case 'Tetradic': return [h, (h + 90) % 360, (h + 180) % 360, (h + 270) % 360];
    case 'Monochromatic': return [h, h, h, h];
    case 'Shades': return [h, h, h, h];
    case 'Tints': return [h, h, h, h];
    default: return [h];
  }
}
export function harmonyColors(h, s, v, kind) {
  if (kind === 'Monochromatic') return [hsvToRgb(h, s, 40), hsvToRgb(h, s, 60), hsvToRgb(h, s, 80), hsvToRgb(h, s, 100)].map(([r, g, b]) => rgbToHex(r, g, b));
  if (kind === 'Shades') return [1.0, 0.75, 0.5, 0.25].map(k => rgbToHex(...hsvToRgb(h, s, v * k)));
  if (kind === 'Tints') return [0, 25, 50, 75].map(k => rgbToHex(...hsvToRgb(h, Math.max(0, s - k), v)));
  return harmony(h, kind).map(hh => rgbToHex(...hsvToRgb(hh, s, v)));
}
